import axiosInstance from "../../api/axiosInstance";

export const fetchControlledHierarchyAPI = async (adminId) => {
  const controlledHierarchy = await axiosInstance.get(
    `hierarchies/get-controlled-hierarchy${
      adminId ? `?adminId=${adminId}` : ""
    }`
  );

  return controlledHierarchy.data;
};

export const addControlledAdminsAPI = async (adminId, newAdminIds) => {
  const addedControlledHierarchy = await axiosInstance.post(
    "hierarchies/add-controlled-admins",
    { adminId, newAdminIds }
  );

  return addedControlledHierarchy.data;
};

export const removeControlledAdminsAPI = async (adminId, removeAdminIds) => {
  const deletedControlledHierarchy = await axiosInstance.post(
    "hierarchies/remove-controlled-admins",
    { adminId, removeAdminIds }
  );

  return deletedControlledHierarchy.data;
};
